export default function(el, time = 1000){

    setTimeout(()=>{

        let el_top =  ($(window).width()>768)?($(el).offset().top):($(el).offset().top-50)
        console.log(el_top)
        $("HTML, BODY").animate({ scrollTop: el_top}, 500);

    }, time)
    
}


// WEBPACK FOOTER //
// ./src/functions/scrollTo.js